document.addEventListener('DOMContentLoaded',function(){
    var $root;
    var downloadPreview = function() {
        //console.log('download');
        
        var name = $root.attr('data-product-handle') + '.png';
        var link = document.createElement('a');
        link.download = name;
        var imgData = window.cpbImageStorage.views.front.getSnapshot();
        link.href = imgData.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
        link.setAttribute('target', '_blank'); 
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        
    }
    var customJS = function() {
        $root = $('#product-builder');
        var $previewBtn = $('<button class="cpb-download-preview-button" type="button">Download Product Image</span></button>');
        $previewBtn.closest('button').on('click', downloadPreview);
        $previewBtn.insertBefore( $root.find('.cpb-product-actions-container .cpb-add-to-cart-button'));
       
        
    };
    var loadCpb = function() {
        if( $('.cpb-add-to-cart-button span').length) { 
            customJS();
        }
        else { 
            window.requestAnimationFrame(loadCpb);
        } 
         
    };         
    loadCpb();
    
});

